import { TableCell } from '@mui/material'
import classNames from 'classnames'
import { DateUtils, type Nil } from '@pbt/pbt-ui-components'

import styles from './ConversationRow.module.scss'

const MessageDateCell = ({
  lastMessageDate,
  noBottomBorder,
}: {
  lastMessageDate: string | Nil
  noBottomBorder?: boolean
}) => (
  <TableCell
    className={classNames(styles.tableCell, styles.messageDateCell, {
      [styles.noBorder]: noBottomBorder,
    })}
  >
    {DateUtils.formatDate(lastMessageDate, false, '[full-date-time]')}
  </TableCell>
)

export default MessageDateCell
